if (!customElements.get('similar-items')) {
  class SimilarItems extends HTMLElement {
    connectedCallback() {
      this.performRecommendations();
    }

    performRecommendations() {
      console.log(this)
      const recommendations = this.querySelector(
        '[data-recommendations]'
      );

      if (!recommendations) return;

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const recommendationsHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]')?.innerHTML;

          if (!recommendationsHTML) return;

          this.classList.remove('hidden');

          recommendations.innerHTML = recommendationsHTML;
        })
    }
  }

  customElements.define('similar-items', SimilarItems);
}